import { render } from "./reset-password.vue?vue&type=template&id=7bde91bb&scoped=true"
import script from "./reset-password.vue?vue&type=script&lang=ts"
export * from "./reset-password.vue?vue&type=script&lang=ts"

import "./reset-password.vue?vue&type=style&index=0&id=7bde91bb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7bde91bb"

export default script